import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import {
  faQuestion,
  faPlayCircle,
  faPause,
  faCircle,
  faFlag,
  faFilter,
  faMarker,
  faGripVertical,
  faEnvelope,
  faPaperPlane,
  faCheckCircle,
  faCalendarWeek,
  faReceipt,
  faPaste,
  faEllipsisV,
  faVideoSlash,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faParagraph,
  faListUl,
  faListOl,
  faUndoAlt,
  faRedoAlt,
  faArrowLeft,
  faEye,
  faCloudUploadAlt,
  faCloud,
  faImage,
  faMinus,
  faCheck,
  faAngleDown,
  faAngleDoubleUp,
  faInfo,
  faInfoCircle,
  faMagic,
  faLayerGroup,
  faTag,
  faChartPie,
  faChartArea,
  faChartLine,
  faChartBar,
  faFileInvoiceDollar,
  faHourglassHalf,
  faHourglassStart,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faServer,
  faLock,
  faPlay,
  faSquare,
  faDatabase,
  faCode,
  faQuoteLeft,
  faQuoteRight,
  faCommentDollar,
  faShapes,
  faAward,
  faStar,
  faMedal,
  faComment,
  faCommentDots,
  faPlug,
  faExternalLinkAlt,
  faTimesCircle,
  faCheckDouble,
  faAngleUp,
  faClock,
  faExclamation,
  faDollarSign,
  faCreditCard,
  faClipboard,
  faChevronRight,
  faExclamationTriangle,
  faShare,
  faUsers,
  faChevronUp,
  faChevronDown,
  faLink,
  faUnlink,
  faLongArrowAltUp,
  faCaretUp,
  faCaretDown,
  faPlus,
  faArrowUp,
  faArrowDown,
  faCog,
  faCogs,
  faGlobe,
  faKey,
  faBullhorn,
  faRedo,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import { faStripe, faFacebook, faInstagram, faTwitter, faLinkedinIn, faAngellist, faGithub } from '@fortawesome/free-brands-svg-icons';

library.add(
  faCalendarWeek,
  faPlug,
  faCircle,
  faCheckCircle,
  faReceipt,
  faQuestion,
  faPlayCircle,
  faPlay,
  faPause,
  faFlag,
  faFilter,
  faMarker,
  faGripVertical,
  faEnvelope,
  faPaperPlane,
  faStripe,
  faFileInvoiceDollar,
  faFacebook,
  faInstagram,
  faTwitter,
  faLinkedinIn,
  faAngellist,
  faGithub,
  faPaste,
  faEllipsisV,
  faVideoSlash,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faParagraph,
  faListUl,
  faListOl,
  faUndoAlt,
  faRedoAlt,
  faArrowLeft,
  faEye,
  faCloudUploadAlt,
  faCloud,
  faImage,
  faMinus,
  faCheck,
  faAngleDown,
  faAngleDoubleUp,
  faInfo,
  faInfoCircle,
  faMagic,
  faLayerGroup,
  faTag,
  faChartPie,
  faChartArea,
  faChartLine,
  faChartBar,
  faHourglassHalf,
  faHourglassStart,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faServer,
  faLock,
  faSquare,
  faCheck,
  faDatabase,
  faQuoteLeft,
  faQuoteRight,
  faCode,
  faCommentDollar,
  faComment,
  faShapes,
  faAward,
  faStar,
  faMedal,
  faCommentDots,
  faExternalLinkAlt,
  faTimesCircle,
  faCheckDouble,
  faAngleUp,
  faAngleDoubleUp,
  faAngleDown,
  faClock,
  faExclamation,
  faDollarSign,
  faCreditCard,
  faClipboard,
  faChevronRight,
  faExclamationTriangle,
  faShare,
  faUsers,
  faChevronUp,
  faChevronDown,
  faLink,
  faUnlink,
  faLongArrowAltUp,
  faCaretUp,
  faCaretDown,
  faPlus,
  faArrowUp,
  faArrowDown,
  faCog,
  faCogs,
  faGlobe,
  faKey,
  faBullhorn,
  faRedo,
  faHeart
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
